(function () {
  function iniciarEncabezado() {
    var encabezado = document.querySelector('[data-encabezado]');
    if (!encabezado) return;

    var cajon = document.querySelector('[data-cajon]');
    var velo = document.querySelector('[data-velo-cajon]');
    var abrir = encabezado.querySelector('[data-abrir-cajon]');
    var cerrar = document.querySelector('[data-cerrar-cajon]');
    var contenedorScroll = document.querySelector('.page-wrapper');
    var umbral = parseInt(encabezado.getAttribute('data-umbral'), 10);
    if (isNaN(umbral)) umbral = 40;

    function obtenerScrollActual() {
      var scrollVentana = window.scrollY || window.pageYOffset || 0;
      var scrollContenedor = contenedorScroll ? contenedorScroll.scrollTop : 0;
      return Math.max(scrollVentana, scrollContenedor);
    }

    function medirAltura() {
      var alto = encabezado.offsetHeight + 'px';
      encabezado.style.setProperty('--encabezado-altura', alto);
      document.documentElement.style.setProperty('--encabezado-altura', alto);
    }

    function actualizarEspacioFijo() {
      var necesitaEspacio =
        encabezado.classList.contains('encabezado--fijo') &&
        !encabezado.classList.contains('encabezado--superpuesto');
      document.body.classList.toggle('encabezado-fijo-con-espacio', necesitaEspacio);
    }

    function alDesplazar() {
      if (obtenerScrollActual() > umbral) {
        encabezado.classList.add('encabezado--activo');
      } else {
        encabezado.classList.remove('encabezado--activo');
      }
    }

    function abrirCajon() {
      if (!cajon || !velo) return;
      velo.hidden = false;
      window.requestAnimationFrame(function () {
        velo.classList.add('encabezado-velo--visible');
        cajon.classList.add('encabezado-cajon--abierto');
      });
      cajon.setAttribute('aria-hidden', 'false');
      if (abrir) abrir.setAttribute('aria-expanded', 'true');
      document.body.classList.add('encabezado-sin-scroll');
    }

    function cerrarCajon() {
      if (!cajon || !velo) return;
      velo.classList.remove('encabezado-velo--visible');
      cajon.classList.remove('encabezado-cajon--abierto');
      cajon.setAttribute('aria-hidden', 'true');
      if (abrir) abrir.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('encabezado-sin-scroll');
      window.setTimeout(function () {
        if (!cajon.classList.contains('encabezado-cajon--abierto')) velo.hidden = true;
      }, 320);
    }

    if (abrir) abrir.addEventListener('click', abrirCajon);
    if (cerrar) cerrar.addEventListener('click', cerrarCajon);
    if (velo) velo.addEventListener('click', cerrarCajon);

    var buscador = document.querySelector('[data-buscador]');
    var veloBuscador = document.querySelector('[data-velo-buscador]');
    var abrirBuscadorBotones = document.querySelectorAll('[data-abrir-buscador]');
    var cerrarBuscadorBoton = document.querySelector('[data-cerrar-buscador]');
    var inputBuscador = document.querySelector('[data-input-buscador]');
    var resultadosBuscador = document.querySelector('[data-resultados-buscador]');
    var popularesBuscador = document.querySelector('[data-populares-buscador]');
    var formularioBuscador = document.querySelector('[data-formulario-buscador]');
    var temporizadorBuscador;

    function abrirBuscador() {
      if (!buscador || !veloBuscador) return;
      cerrarCajon();
      veloBuscador.hidden = false;
      window.requestAnimationFrame(function () {
        veloBuscador.classList.add('encabezado-velo--visible');
        buscador.classList.add('encabezado-buscador--abierto');
      });
      buscador.setAttribute('aria-hidden', 'false');
      document.body.classList.add('encabezado-sin-scroll');
      window.setTimeout(function () {
        if (inputBuscador) inputBuscador.focus();
      }, 200);
    }

    function cerrarBuscador() {
      if (!buscador || !veloBuscador) return;
      veloBuscador.classList.remove('encabezado-velo--visible');
      buscador.classList.remove('encabezado-buscador--abierto');
      buscador.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('encabezado-sin-scroll');
      window.setTimeout(function () {
        if (!buscador.classList.contains('encabezado-buscador--abierto')) veloBuscador.hidden = true;
      }, 320);
    }

    function alternarPopulares(mostrar) {
      if (popularesBuscador) popularesBuscador.hidden = !mostrar;
    }

    function escaparHtml(texto) {
      var contenedor = document.createElement('div');
      contenedor.textContent = texto || '';
      return contenedor.innerHTML;
    }

    function renderizarResultadosBuscador(datos, termino) {
      if (!resultadosBuscador) return;
      var productos = (datos.resources && datos.resources.results && datos.resources.results.products) || [];

      if (productos.length === 0) {
        resultadosBuscador.innerHTML =
          '<p class="encabezado-buscador__vacio">No se encontraron resultados para “' + escaparHtml(termino) + '”.</p>';
        resultadosBuscador.hidden = false;
        alternarPopulares(false);
        return;
      }

      var html = '<div class="encabezado-buscador__rejilla">';
      productos.forEach(function (producto) {
        html +=
          '<a class="encabezado-buscador__resultado" href="' + producto.url + '">' +
          (producto.featured_image
            ? '<img class="encabezado-buscador__resultado-imagen" src="' +
              producto.featured_image.url +
              '" alt="' +
              escaparHtml(producto.featured_image.alt) +
              '" loading="lazy">'
            : '<span class="encabezado-buscador__resultado-imagen encabezado-buscador__resultado-imagen--vacia"></span>') +
          '<span class="encabezado-buscador__resultado-info">' +
          '<span class="encabezado-buscador__resultado-titulo">' + escaparHtml(producto.title) + '</span>' +
          '<span class="encabezado-buscador__resultado-precio">' + producto.price + '</span>' +
          '</span>' +
          '</a>';
      });
      html += '</div>';
      html +=
        '<a class="encabezado-buscador__ver-todo" href="' +
        (formularioBuscador ? formularioBuscador.action : '/search') +
        '?q=' +
        encodeURIComponent(termino) +
        '">Ver todos los resultados</a>';

      resultadosBuscador.innerHTML = html;
      resultadosBuscador.hidden = false;
      alternarPopulares(false);
    }

    function buscarEnVivo(termino) {
      if (!resultadosBuscador) return;
      if (!termino) {
        resultadosBuscador.hidden = true;
        resultadosBuscador.innerHTML = '';
        alternarPopulares(true);
        return;
      }

      fetch(
        '/search/suggest.json?q=' +
          encodeURIComponent(termino) +
          '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last'
      )
        .then(function (respuesta) {
          if (!respuesta.ok) throw new Error('predictive search failed');
          return respuesta.json();
        })
        .then(function (datos) {
          renderizarResultadosBuscador(datos, termino);
        })
        .catch(function () {
          resultadosBuscador.hidden = true;
        });
    }

    abrirBuscadorBotones.forEach(function (boton) {
      boton.addEventListener('click', abrirBuscador);
    });
    if (cerrarBuscadorBoton) cerrarBuscadorBoton.addEventListener('click', cerrarBuscador);
    if (veloBuscador) veloBuscador.addEventListener('click', cerrarBuscador);

    if (inputBuscador) {
      inputBuscador.addEventListener('input', function () {
        var termino = inputBuscador.value.trim();
        window.clearTimeout(temporizadorBuscador);
        temporizadorBuscador = window.setTimeout(function () {
          buscarEnVivo(termino);
        }, 280);
      });
    }

    if (popularesBuscador) {
      popularesBuscador.querySelectorAll('[data-termino-popular]').forEach(function (pildora) {
        pildora.addEventListener('click', function () {
          var termino = pildora.getAttribute('data-termino-popular');
          if (inputBuscador) {
            inputBuscador.value = termino;
            inputBuscador.focus();
          }
          buscarEnVivo(termino);
        });
      });
    }

    if (formularioBuscador) {
      formularioBuscador.addEventListener('submit', function (evento) {
        if (!inputBuscador || !inputBuscador.value.trim()) evento.preventDefault();
      });
    }

    if (encabezado.classList.contains('encabezado--hover-solido')) {
      encabezado.addEventListener('mouseenter', function () {
        encabezado.classList.add('encabezado--hover');
      });
      encabezado.addEventListener('mouseleave', function () {
        encabezado.classList.remove('encabezado--hover');
      });
      encabezado.addEventListener('focusin', function () {
        encabezado.classList.add('encabezado--hover');
      });
      encabezado.addEventListener('focusout', function () {
        if (!encabezado.contains(document.activeElement)) {
          encabezado.classList.remove('encabezado--hover');
        }
      });
    }

    document.addEventListener('keydown', function (evento) {
      if (evento.key === 'Escape') {
        cerrarCajon();
        cerrarBuscador();
      }
    });

    if (encabezado.classList.contains('encabezado--movil-tocar')) {
      encabezado.addEventListener(
        'touchstart',
        function () {
          encabezado.classList.add('encabezado--tocado');
        },
        { passive: true }
      );

      document.addEventListener(
        'touchstart',
        function (evento) {
          if (!encabezado.contains(evento.target)) {
            encabezado.classList.remove('encabezado--tocado');
          }
        },
        { passive: true }
      );
    }

    medirAltura();
    actualizarEspacioFijo();
    alDesplazar();
    window.addEventListener('resize', medirAltura);
    window.addEventListener('scroll', alDesplazar, { passive: true });
    if (contenedorScroll) {
      contenedorScroll.addEventListener('scroll', alDesplazar, { passive: true });
    }

    if ('ResizeObserver' in window) {
      new ResizeObserver(medirAltura).observe(encabezado);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarEncabezado);
  } else {
    iniciarEncabezado();
  }

  document.addEventListener('shopify:section:load', iniciarEncabezado);
})();